import Main from '@/views/main.vue'

import {homemainMenuRouter} from './homeMain'
import {homedetailOtherRouter} from './homedetail'

const homeMainRoute = {
  // has: 'homepage',
  path: '/',
  icon: 'android-people',
  name: 'homeMenuRouter',
  title: '首页',
  component: Main,
  children: [
    ...homemainMenuRouter
  ]
}

const homeOtherRouter = {
  path: '/',
  icon: 'android-people',
  name: 'homeOtherRouter',
  title: '维修接车',
  component: Main,
  children: [
    ...homedetailOtherRouter
  ]
}

export {homeMainRoute, homeOtherRouter}



// WEBPACK FOOTER //
// ./src/router/home/index.js